import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"
import {
  MAP_STYLES,
  MapStyle,
  MapStyleEntry,
} from "@/components/maps/MapManager"
import {
  Command,
  CommandGroup,
  CommandItem,
  CommandList,
} from "@/components/ui/command"
import { cn } from "@/lib/utils"
import { useState } from "react"
import { Button } from "@blueprintjs/core"
import classNames from "classnames"
import { useTranslation } from "react-i18next"
import RegionBordersSettings from "./RegionBordersSettings"

const ChangeMapStyle = ({
  currentStyle,
  onChangeMapStyle,
  className = "absolute left-[10px] top-[10px] z-10",
}: {
  currentStyle?: MapStyle
  onChangeMapStyle?: (style: MapStyle) => void
  /** Placement; the default is the old fixed spot for maps without a column */
  className?: string
}) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState<boolean>(false)
  return (
    // Lifted while open so the menu is not covered by the buttons below it.
    <div className={cn(className, open && "z-30")}>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            id="change-map-style"
            icon="map"
            className={classNames("dark:bg-gray-700 dark:text-white")}
            title={t("maps.changeMapStyle.title")}
          />
        </PopoverTrigger>
        <PopoverContent className="w-52 p-0" align="start" portal={false}>
          <Command>
            <CommandList>
              <CommandGroup>
                {Object.entries<MapStyleEntry>(MAP_STYLES).map(([key]) => (
                  <CommandItem
                    key={key}
                    onSelect={() => {
                      setOpen(false)
                      onChangeMapStyle?.(key as MapStyle)
                    }}
                    className={cn(
                      currentStyle === key &&
                        "bg-accent text-accent-foreground",
                    )}
                  >
                    {t(`maps.changeMapStyle.styles.${key as MapStyle}`)}
                  </CommandItem>
                ))}
              </CommandGroup>
            </CommandList>
          </Command>
          <RegionBordersSettings />
        </PopoverContent>
      </Popover>
    </div>
  )
}

export default ChangeMapStyle
